import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-gray-900 via-blue-900 to-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <div className="flex justify-center space-x-8 mb-4">
          <a href="https://github.com" target="_blank" rel="noopener noreferrer">
            <FaGithub className="text-3xl hover:text-blue-400 hover:scale-110 transition-all duration-300" />
          </a>
          <a href="https://linkedin.com/in/teerth-pandya" target="_blank" rel="noopener noreferrer">
            <FaLinkedin className="text-3xl hover:text-blue-400 hover:scale-110 transition-all duration-300" />
          </a>
          <a href="mailto:teerthpandya2742002@gmail.com">
            <FaEnvelope className="text-3xl hover:text-blue-400 hover:scale-110 transition-all duration-300" />
          </a>
        </div>
        <p className="text-gray-300 text-lg">© 2025 Teerth Pandya. Built with Passion & Precision.</p>
      </div>
    </footer>
  );
};

export default Footer;